import { AnalyticsTool } from "landings/Analytics/AnalyticsTool";
import { FundPrivilegeType } from "trade_fund_lib";
import Mixpanel from "landings/Analytics/Mixpanel";
import Constants from "utils/Constants";

/**
 * Web上报 Google Analytics
 */
export const PionexReportV2 = {
    trackingEvent(...params: Parameters<typeof AnalyticsTool.trackingEvent>) {
        AnalyticsTool.trackingEvent(...params);
    },
    /**
     * 交易页面点击行为
     * 1.账户设置  2.系统设置  3.Trade  4.My bots  5.资产按钮  6.只显示当前交易对  7.查看历史订单
     * @param type
     */
    reportClickInfo(button: 1 | 2 | 3 | 4 | 5 | 6 | 7) {
        AnalyticsTool.trackingEvent({
            category: "pionex_exchange_page",
            action: JSON.stringify({ button }),
        });
    },

    /**
     * 系统设置情况
     * 1.Currency setting  2. Language setting  3.white mode  4.Reverse green and red  5.Google Authenticator  6.Fees
     * 11. theme normal 12. theme dark
     * 21. red up 22. green up 23 start migrate
     * @param index
     */
    reportSystemOption(button: 1 | 2 | 3 | 4 | 5 | 6 | 11 | 12 | 21 | 22 | 23) {
        AnalyticsTool.trackingEvent({
            category: "pionex_system_set",
            action: JSON.stringify({ button }),
        });
    },

    /**
     * 账户设置点击情况
     * 1.Deposit  2.Withdraw  3.Referral program  4.Balance 5.custom service  6.fees
     * @param type
     */
    reportAccountClick(type: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8) {
        AnalyticsTool.trackingEvent({
            category: "pionex_account_set",
            action: JSON.stringify({ button: type }),
        });
    },

    /**
     * 资产余额点击情况
     * 1.Balance details  2.Hide balance  3.Depoist  4.Withdraw
     * @param type
     */
    reportBalanceClick(button: 1 | 2 | 3 | 4) {
        AnalyticsTool.trackingEvent({
            category: "pionex_balance_card",
            action: JSON.stringify({ button }),
        });
    },

    /**
     * 选择交易对排序情况
     * 1.PAIR  2.VOL  3.PRICE  4.CHANGE
     * @param type
     */
    reportSymbolSortTyle(type: 1 | 2 | 3 | 4) {
        AnalyticsTool.trackingEvent({
            category: "pionex_pair_rank",
            action: JSON.stringify({ type }),
        });
    },

    /**
     * 资产详情页面情况
     *
     * @param coin
     * @param operation 1.Deposit  2.Withdraw  3.Trade
     */
    reportCoinOperate(data: { coin: string; operation: 1 | 2 | 3 }) {
        AnalyticsTool.trackingEvent({
            category: "pionex_balance_detail",
            action: JSON.stringify(data),
        });
    },

    /**
     * Deposit页面
     *
     * @param coin
     * @param dwType "deposit" | "withdraw"
     * @param operation  1.点击QR code  2.点击COPY  3.点击Transaction ID  4.点击了go trading的交易对
     */
    reportDepositInfo(data: { coin: string; dwType: "deposit" | "withdraw"; operation: 1 | 2 | 3 | 4 }) {
        AnalyticsTool.trackingEvent({
            category: "pionex_deposit",
            action: JSON.stringify(data),
        });
    },

    /**
     * Withdraw页面
     * @param coin
     * @param operation  1.点击submit成功  2.点击submit报错  3.点击Transaction ID  4.点击了go trading的交易对
     */
    reportWithdrawInfo(data: { coin: string; operation: 1 | 2 | 3 | 4 }) {
        AnalyticsTool.trackingEvent({
            category: "pionex_withdraw",
            action: JSON.stringify(data),
        });
    },

    /**
     * Mybots页面
     * @param tab   同OrderTypeDesc
     */
    reportMybotsOperate(tab: string) {
        AnalyticsTool.trackingEvent({
            category: "pionex_mybots",
            action: JSON.stringify({ tab }),
        });
    },

    /**
     * 交易页面订单处
     * @param cardType  1.Trading bots  2.Manual orders
     * @param operation  "cancel" | "share" | "detail"
     * @param state 订单状态  同Order.state
     */
    reportBotCardOperate(data: { tab: string; state: "cancel" | "share" | "detail"; operation: string }) {
        AnalyticsTool.trackingEvent({
            category: "pionex_order_operate",
            action: JSON.stringify(data),
        });
    },

    /**
     * Referral program页面
     * @param operation  1.Copy link  2.Copy code   3.History   4.BUB Rank
     */
    reportRefferalOperation(operation: 1 | 2 | 3 | 4) {
        AnalyticsTool.trackingEvent({
            category: "pionex_referral_program",
            action: JSON.stringify({ operation }),
        });
    },

    /**
     *
     * @param order 1. Grid 2.TTP 3.AIP 4.TWAP 5.StopLimit 6:Limit 7:Market
     * @param operation
     */
    reportCreateOrderResult(data: { order: 1 | 2 | 3 | 4 | 5 | 6 | 7; operation: number }) {
        AnalyticsTool.trackingEvent({
            category: "pionex_strategy_use",
            action: JSON.stringify(data),
        });
    },

    /**
     *
     * @param action 事件名称
     * @param timestemp 耗时(毫秒)
     * @param info 其他信息
     */
    reportActionPerformance(data: { action: string; timestemp: number; info?: { [k: string]: any } }) {
        if (!data.info) data.info = {};
        AnalyticsTool.trackingEvent({
            category: "pionex_action_performance",
            action: JSON.stringify(data),
        });
    },

    /**
     *
     * @param tab 1.登录tab   2.注册tab
     * @param operation 1.点击这个tab   2.点击发送验证码   3.点击登录/注册大按钮   4.点击登录/注册后成功  5.点击登录/注册后失败  6.点击忘记密码  7.点击加入社群
     */
    pionex_log_page(data: { tab: 1 | 2; operation: 1 | 2 | 3 | 4 | 5 | 6 | 7 }) {
        AnalyticsTool.trackingEvent({
            category: "pionex_log_page",
            action: JSON.stringify(data),
        });
    },

    /**
     *
     * @param headertab 小按钮登录注册
     *
     */
    header_pionex_log_page(headertab: "header_sing" | "pihodl_sign") {
        AnalyticsTool.trackingEvent({
            category: "header_pionex_log_page",
            action: JSON.stringify({ headertab }),
        });
    },

    /**
     *
     * @param operation 1What's Pionex 2Market 3CoinCap 4点击iOS 5点击Android 6点击Market的任意交易对 7点击CoinCap任意交易对
     */
    pionex_main_page(operation: 1 | 2 | 3 | 4 | 5 | 6 | 7) {
        AnalyticsTool.trackingEvent({
            category: "pionex_main_page",
            action: JSON.stringify({ operation }),
        });
    },

    /**
     *
     * @param setting 1，币价上涨后卖出收益+网格套利收益 2. 仅计算网格套利收益
     *
     */
    reportProfitModel(setting: string) {
        AnalyticsTool.trackingEvent({
            category: "pionex_profit_set",
            action: JSON.stringify({ setting: setting }),
        });
    },

    /**
     *
     * @param setting 1成功修改用户名 2成功设置头像 3成功解绑谷歌验证 4成功修改Password
     */
    pionex_personal_set(setting: 1 | 2 | 3 | 4) {
        AnalyticsTool.trackingEvent({
            category: "pionex_personal_set",
            action: JSON.stringify({ setting }),
        });
    },

    reportFundInviteAction(operation: number) {
        AnalyticsTool.trackingEvent({
            category: "pionex_whats_PiHodl",
            action: JSON.stringify({ operation }),
        });
    },

    reportFundTransferResult(data: { coin: string; operation: number; direction: string }) {
        AnalyticsTool.trackingEvent({
            category: "pionex_PiHodl_transfer",
            action: JSON.stringify(data),
        });
    },

    reportFundPurchaseResult(data: { fundType: FundPrivilegeType; coin: string }) {
        const { fundType, coin } = data;
        let result = 0;
        if (fundType === "YEARLY_PRIVILEGE") {
            if (coin === "BTC") {
                result = 3;
            } else if (coin === "USDT") {
                result = 4;
            }
        } else if (fundType === "YEARLY") {
            if (coin === "BTC") {
                result = 1;
            } else if (coin === "USDT") {
                result = 2;
            }
        }
        AnalyticsTool.trackingEvent({
            category: "pionex_purchase_PiHodl",
            action: JSON.stringify({ operation: result }),
        });
    },

    reportPurchaseActionResult(operation: number) {
        AnalyticsTool.trackingEvent({
            category: "pionex_purchase_PiHodl",
            action: JSON.stringify({ operation }),
        });
    },

    reportMigrateResult(operation: number) {
        AnalyticsTool.trackingEvent({
            category: "pionex_migrate",
            action: JSON.stringify({ operation }),
        });
    },

    reportMigrateCheckResult(operation: number) {
        AnalyticsTool.trackingEvent({
            category: "pionex_migrate_check",
            action: JSON.stringify({ operation }),
        });
    },

    /**
     * 查看达人榜订单备注
     */
    reportExpertRemarkClick(orderId: string) {
        AnalyticsTool.trackingEvent({
            category: "pionex_contest_expert_bot_remark",
            action: JSON.stringify({ orderId }),
        });
    },

    /**
     * 查看大赛规则
     */
    reportContestRulesClick(contestId: string) {
        AnalyticsTool.trackingEvent({
            category: "pionex_contest_rules_clicked",
            action: JSON.stringify({ contestId }),
        });
    },

    /**
     * 切换大赛tab
     */
    reportContestTabClick(tabName: string) {
        AnalyticsTool.trackingEvent({
            category: "pionex_contest_tab_clicked",
            action: JSON.stringify({ tabName }),
        });
    },

    /**
     * 打开1v1教程页面
     */

    reportTutorialGuide() {
        AnalyticsTool.trackingEvent({
            category: "pionex_tutorial_guide_click",
            action: "open pionex guide page",
        });
    },

    /**
     * 1v1教程页面查看达人订单参数
     */

    reportTutorialGuideOrderDetails(orderId: string) {
        AnalyticsTool.trackingEvent({
            category: "pionex_tutorial_guide_click_order_details",
            action: JSON.stringify({ orderId }),
        });
    },

    /**
     * 允许授权第三方登录
     * @param userId
     */
    reportAuthOtherLogin(userId: string) {
        AnalyticsTool.trackingEvent({
            category: "pionex_auth_other_login",
            action: userId,
        });
        Mixpanel.report.userAuthorization(userId);
    },

    /**
     * Jumio KYC 相关上报
     */
    JumioKYC: {
        /**
         * 上报用户是从什么地方进入到当前版本KYC的。
         * @param fromType
         */
        reportEnteredFrom(fromType: string) {
            Mixpanel.trackEvent("pionex_kyc_entered_from", { from_web: fromType });
        },
        /**
         * 有哪些用户进入到了JumioKYC的一级
         * @param userId
         */
        reportStep1Entered(userId: string) {
            Mixpanel.trackEvent("pionex_kyc_step1_entered", { from_web: 1, userId });
        },
        /**
         * 有哪些用户提交了Jumio的一级KYC
         * @param userId
         */
        reportStep1Submitted(userId: string) {
            Mixpanel.trackEvent("pionex_kyc_step1_submitted", { from_web: 1, userId });
        },
        /**
         * 有哪些用户进入到了JumioKYC的二级
         * @param userId
         */
        reportStep2Entered(userId: string) {
            Mixpanel.trackEvent("pionex_kyc_step2_entered", { from_web: 1, userId });
        },
    },
    reportNewUserViewing() {
        // 若已经注册，将不再上报访问事件
        if (!window.localStorage.getItem("--us-new-user-ana-registered--"))
            AnalyticsTool.trackingEvent({
                category: "pionex_new_user_viewing",
                action: Constants.deviceId,
            });
    },
    reportNewUserRegistered(userId: string) {
        window.localStorage.setItem("--us-new-user-ana-registered--", "1");
        AnalyticsTool.trackingEvent({
            category: "pionex_new_user_registered",
            action: userId,
        });
    },
};
